import { useQuery } from '@tanstack/react-query';
import { fetchWorkOrderHistory } from "./endpoints";
import { getErrorMessage } from 'modules/CustomerProducts/helpers';
export const useWorkOrderHistory = (workOrderId) => {
    const { data: workOrderHistory = [], isFetching: isWorkOrderHistoryFetching, isLoading: isWorkOrderHistoryLoading, isError, error: workOrderHistoryError, refetch, } = useQuery({
        queryKey: ['workorder-history', workOrderId],
        queryFn: () => fetchWorkOrderHistory(workOrderId),
        enabled: !!workOrderId,
    });
    const errorMessage = getErrorMessage(workOrderHistoryError);
    return {
        workOrderHistory,
        isWorkOrderHistoryFetching,
        isWorkOrderHistoryLoading,
        isError,
        workOrderHistoryError: errorMessage,
        refetch,
    };
};
